import { useEffect } from "react";

/** Per-page SEO: sets document title + meta description. */
export const Seo = ({ title, description }) => {
  useEffect(() => {
    document.title = title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", description);
  }, [title, description]);
  return null;
};
